import { SelectedStockItem, StockJournal } from "./stock.model";

export class OnGetStock {
  static readonly type = '[Stock] Get Stock';
  constructor(public payload: { gridUUID: string; }) { }
}

export class OnGetStockJournals {
  static readonly type = '[Stock] Get Stock Journals';
}

export class OnCreateStockJournal {
  static readonly type = '[Stock] Create Stock Journal';
  constructor(public payload: Partial<StockJournal>) { }
}

export class OnRemoveStockAdjustment {
  static readonly type = '[Stock] Delete Stock Journal';
  constructor(public id: string) { }
}

export class OnSetSelectedStock {
  static readonly type = '[Stock] Set Selected Stock';
  constructor(public payload: SelectedStockItem) { }
}

export class OnThrowCantPerformActionOnGroupedStockItems {
  static readonly type = '[Stock] Throw Error on Grouped Stock Items';
}

export class GetAllInternalGrades {
  static readonly type = '[Stock] Get All Internal Grades';
}
